<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称" >
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <!-- <el-form-item label="因子">
					<el-select v-model="filters.facKeyword" style="max-width:150px" filterable>
					<el-option
							v-for="item in factors"
							:label="item.name"
							:value="item.keyWord" :key="item.keyWord">
						</el-option>
					</el-select>
				</el-form-item> -->
                <el-form-item label="数据类型">
					<el-select v-model="filters.dataType" placeholder="请选择数据类型" >
						<el-option label="小时" value="hour"></el-option>
						<el-option label="天" value="day"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="时间范围">
					<el-date-picker
                        v-model="filters.time" type="datetimerange" unlink-panels range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
                     <form-query-button  @select-type="selectReviewList" >  </form-query-button>
				</el-form-item>
			</el-form>
		</el-col>

		<el-table :data="dataList" border highlight-current-row v-loading="listLoading" style="width: 100%;" size="small" id="mytable" ref="reviewTable">
            <el-table-column type="index" label="序号" ></el-table-column>
			<el-table-column label="时间" prop="time"></el-table-column>
            <el-table-column label="审核前" prop="before"></el-table-column>
            <el-table-column label="审核后" prop="after"></el-table-column>
            <el-table-column label="差值"  prop="diff"></el-table-column>
		</el-table>
        
        <el-radio-group v-model="filters.facKeyword" @input="handleData">
            <el-radio v-for="item in factors"  :label="item.KeyWord" :key="item.KeyWord">{{item.Name}}</el-radio>
        </el-radio-group>

        <el-col :span="24"   v-loading="listLoading">
            <div id="chartLine"></div>
        </el-col>
	</section>
</template>

<script>
	import { getProjects,selectReviewList,getDevicesByProjectId,getFactorsByMn} from '../../api/api';
    import * as echarts from "echarts";   
    import {formatDate,reviewFactor,in_array} from '../../../static/fun.js';

    import FormQueryButton from '../../components/myButton/FormQueryButton.vue'

    export default {
        props: {
            collapsed: {
                type: Boolean,
            },
        },
        components: { FormQueryButton },
		data() {
			return {
				pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                filters: {
					projectId:"",
					mn:"",
                    facKeyword:'',
                    dataType:"hour",
                    time:''
				},
				listLoading: false,
				dataList:[],
                dataListTep:[],
				projects:[],
                devices:[],
                factors:[],

                userId:sessionStorage.getItem('userId'),
                chartLine:null,
                type:sessionStorage.getItem("type"),
                formHeight:0,
                aData:[], 
                deviceMap:new Map(),
                projectMap:new Map(),
                firstFlag:true,
			}
			
		},
        watch: {
            'collapsed': {
                handler (val) {
                    if(this.chartLine!=null){
                        this.chartLine.resize();
                    }
                },
                deep: true
            },
        },
		methods: {
            reset(){
                this.filters={
                    projectId:"",
					mn:"",
                    facKeyword:'',
                    time:''
                }
            },
            selectReviewList(){
                var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
					var day=366;
					//如果开始时间超过三个月
					var d1 = new Date(this.filters.time[0]);
					var d2 = new Date(this.filters.time[1]);
					var days=parseInt(d2 - d1) / 1000 / 3600 / 24 ;
					if(days>day){
						this.$message({
							message: "选择时间范围超过"+day+"天",
							type: 'warn'
						})
						return;
					}
                }
				let para = {
                    dataType:this.filters.dataType,
                    mn:this.filters.mn,
					startTime: starttime,
                    endTime: endtime
				};
                
                if(para.mn==""){
                    this.$message({
                        message: "请选择设备",
                        type: 'warn'
                    })
                    return;
                }
               
				this.listLoading = true;
                selectReviewList(para).then((res) => {  //todo
                    this.listLoading = false;
                    if(res.data.result==false||res.data.result=="false"){
                        this.$message({
                            message: "查询出错,请重试",
                            type: 'warn'
                        })
                        return;
                    }else{
                        this.dataListTep = res.data.datas; 
                       this.handleData();
                    }
                });
            },
            handleData(){
                var seriesData=[
                    {
                        type:'line',
                        name:'审核前数据',
                        connectNulls:false,
                        color:'#02e050',
                        data:[]
                    },
                    {
                        type:'line',
                        name:'审核后数据',
                        connectNulls:false,  
                        color:'#48c8ed',
                        data:[]
                    }
                ];
                this.aData=[];
                var i=0;

                this.dataList= JSON.parse(JSON.stringify(this.dataListTep));
                this.dataList.forEach(element => {
                    element.before=element[this.filters.facKeyword+"Original"];
                    element.after=element[this.filters.facKeyword];
                    var a=Number(element.before);
                    var b=Number(element.after);
                    var diff="-";
                    if(!isNaN(a)&&!isNaN(b)){
                        diff=(a-b).toFixed(2);
                    }
                    element.diff=diff;

                    this.aData.push(element.time);
                    seriesData[0].data.push(element.before);
                    seriesData[1].data.push(element.after);
                    this.dataList[i]=element;
                    i++;
                });
                this.drawLineChart(this.aData,seriesData);
            },
            drawLineChart:function(aData,seriesData) {
                this.chartLine = echarts.init(document.getElementById('chartLine'));
                this.chartLine.setOption({
                      tooltip: {
                        trigger: 'axis',
                        formatter: function(params) {
                            var result = params[0].name+'<br>';
                            params.forEach(function(item) {
                                result +=item.seriesName+" : "+'<span style="display:inline-block;min-width:80px">'+ item.data+"</span><br>"
                            });
                            return result;
                        },
                    },
                    toolbox: {
                        show : true,
                        feature: {
                            saveAsImage: {
                                show:true,
                                excludeComponents :['toolbox'],
                                pixelRatio: 2
                            }
                        }
                    },
                    legend: {
                        itemWidth: 10,  // 设置宽度
                        itemHeight: 10, // 设置高度
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        top:60,
                        containLabel: true
                    },
                    xAxis: {
                        boundaryGap: true,
                        name:'时间',
                        data:aData
                    },
                    yAxis: {
                        type: 'value',
                        name:'数值(dB)',
                        scale:true
                    },
                    series:seriesData
                 },true);
            },
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
                    if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
            //获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
                    this.filters.deviceId="";
                    this.devices.forEach(item => {
						this.deviceMap.set(item.mnCode,item.name);
						this.projectMap.set(item.mnCode,item.projectName);
                    });
                    if(this.devices.length>0){
						this.filters.mn=this.devices[0].mnCode;
                        this.getFactorsByMn();
					}
				});
            },
            //获取选中设备可监测的因子
            getFactorsByMn(){
                let para = {
                    mn: this.filters.mn.toString(),
                    dataType:this.dataType
                };
				getFactorsByMn(para).then((res) => {
                    var factors = res.data.data;
                    this.factors=[];
                    var nullFactor=reviewFactor();
                    for (let index = 0; index < factors.length; index++) {
                        const element = factors[index];
                        if(in_array(element.keyword,nullFactor)){
                            this.factors.push(element);
                        }
                    }
                    if(this.factors.length>0){
                        this.filters.facKeyword=this.factors[0].keyword;
                        if(this.firstFlag){
                            this.firstFlag=false;
                            this.selectReviewList();
                        }
                    } 
				});
            },
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				this.formHeight=(hgt-titleHgt-120);

                
                var chartLineDiv=document.getElementById("chartLine");
                if(chartLineDiv!='-'){
                    chartLineDiv.style.height=this.formHeight*0.6+"px";
                    document.getElementById("mytable").style.height=this.formHeight*0.3+"px";
                }
			},
			setTime(){
				var end = new Date();
				var start = new Date();
				start.setTime(start.setDate(start.getDate()-1));
				start.setHours(6);
				start.setMinutes(0);
				start.setSeconds(0);

				end.setHours(5);
				end.setMinutes(59);
				end.setSeconds(59);
				this.filters.time= [formatDate(start), formatDate(end)];
			}
		},
		mounted() {
			var _this=this;
			var timer='-';
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.setTime();
			this.getProjects();
 
            window.onresize = function(){
                if(_this.chartLine!=null){
                    _this.chartLine.resize();
                }
            }
		},
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }
    #mytable{
        margin-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// ReviewDataCompare.vue?50076bd4